import React__default, { Fragment } from 'react';
import { FileContainer } from '../File/FileContainer.js';
import 'clsx';
import './../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../util/Visible/Visible.js';

const FilesList = ({ files, deleteFile, withDivider, hasFileProcessing }) => (React__default.createElement("div", { className: 'c-uploader__files-list' }, files.map((file, index) => {
    const handleDeleteFile = () => () => {
        deleteFile(file.id);
    };
    return (React__default.createElement(Fragment, { key: index },
        React__default.createElement(FileContainer, { key: file.id, file: file, hasFileProcessing: hasFileProcessing, deleteFile: handleDeleteFile() }),
        React__default.createElement(Visible, { when: withDivider && index !== files.length - 1 },
            React__default.createElement("div", { "data-testid": 'file-divider', className: 'c-uploader__file-divider' }))));
})));

export { FilesList as default };
//# sourceMappingURL=FilesList.js.map
